module.exports = __webpack_public_path__ + "static/media/firmCheck.647c5916.svg";